import React from "react";
import { useNavigate } from "react-router-dom";

/** Shown when the customer must verify before sending (server enforces it too). */
export default function VerifyBanner({ verification }) {
  const navigate = useNavigate();
  if (!verification || (verification.idVerified && verification.phoneVerified)) return null;
  return (
    <div className="bg-yellow-50 border border-yellow-200 text-yellow-900 p-3 rounded text-sm mb-4">
      <p className="font-semibold mb-2">Verify your account before sending.</p>
      <div className="flex flex-wrap gap-2">
        {!verification.idVerified && (
          <button className="bg-yellow-600 text-white px-3 py-1 rounded" onClick={() => navigate("/kyc")}>Verify my ID</button>
        )}
        {!verification.phoneVerified && (
          <button className="bg-yellow-600 text-white px-3 py-1 rounded" onClick={() => navigate("/verify-phone")}>Verify my phone</button>
        )}
      </div>
    </div>
  );
}
